var _linearGradient, _linearGradient2, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundFadeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2200,
    viewBox: "0 0 1125 2200",
    width: 1125,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "objectBoundingBox",
    x2: 1,
    y1: 0.472,
    y2: 0.467
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e2f38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#2e2f38",
    stopOpacity: 0.737
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#2e2f38",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2f38"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "objectBoundingBox",
    x1: 0.284,
    x2: 0.283,
    y1: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e2f38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#2e2f38",
    stopOpacity: 0.886
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#2e2f38",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2f38"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1125v2200h-1125z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1125v2200h-1125z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1125v2200h-1125z",
    fill: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundFadeDark);
export default __webpack_public_path__ + "static/media/background-fade-dark.f2b09c9d1185c7740a7d17c0a975decb.svg";
export { ForwardRef as ReactComponent };